module.exports = __webpack_public_path__ + "img/card-layout-active.dc2a2e13.svg";